import axios from "./axios"

/**
 * 檢查服務准入條件,並返回輔助填寫資料
 * @param {*} serviceType
 * @param {*} identType
 * @param {*} identNo
 * @param {*} spNo
 * @param {*} registrationNo
 * @param {*} identificationNo
 * @returns
 */
const check = (
  serviceType,
  identType,
  identNo,
  spNo,
  registrationNo,
  identificationNo
) => {
  return axios
    .post(
      `/protected/api/v1/application/hzmb-mo-renew/${serviceType}/check?identType=${identType}&identNo=${identNo}${
        spNo ? `&spNo=${spNo}` : ""
      }${registrationNo ? `&registrationNo=${registrationNo}` : ""}${
        identificationNo ? `&identificationNo=${identificationNo}` : ""
      }`
    )
    .then((res) => res.data);
};

/**
 * 根據id查詢申請信息
 * @param {*} applicationId 
 * @returns 
 */
const getById = (applicationId) => {
  return axios.get(`/protected/api/v1/application/hzmb-mo-renew/${applicationId}/get`).then(res => res.data)
}

/**
 * 根據spno查詢申請狀態
 * @param {*} spNo 
 * @returns 
 */
 const getStatusBySpNo = (spNo) => {
  return axios.get(`/protected/api/v1/application/hzmb-mo-renew/get/spNo/${spNo}`).then(res => res.data)
}

export default {
  check,
  getById,
  getStatusBySpNo,
};